import { Type } from 'typebox';
import { Attachment } from '../reference/attachment.js';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const AnnouncementEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.announcement),
        subjectKeys: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        title: Type.String({ minLength: 1 }),
        attachments: Type.Optional(Type.Array(Attachment)),
        pendingApproval: Type.Boolean()
    })
]));
